import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';
import { configureStore, combineReducers, EnhancedStore } from '@reduxjs/toolkit';
import serverVars from 'server-vars';
import { checkoutUIReducer } from './checkoutUIReducer';
import { checkoutPaneReducer } from './checkoutPaneReducer';
import { checkoutPaymentReducer } from './checkoutPaymentReducer';
import { checkoutShippingReducer } from './checkoutShippingReducer';
import { checkoutTransactionReducer } from './checkoutTransactionReducer';
import { tradeStatusReducer } from './tradeStatusReducer';
import { deliveryReducer } from './checkoutDeliveryReducer';

const isLocal = serverVars.get('localeDomain') === 'local.intranet.1stdibs.com';

const rootReducer = combineReducers({
    ui: checkoutUIReducer,
    delivery: deliveryReducer,
    shipping: checkoutShippingReducer,
    transaction: checkoutTransactionReducer,
    payment: checkoutPaymentReducer,
    pane: checkoutPaneReducer,
    tradeStatus: tradeStatusReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export function createCheckoutStore(): EnhancedStore<RootState> {
    return configureStore({
        reducer: rootReducer,
        devTools: isLocal,
    });
}

export const store = createCheckoutStore();

export type AppDispatch = typeof store.dispatch;
export type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useCheckoutSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useCheckoutStore: typeof useStore<RootState> = useStore;
